import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useUiLabels } from "../labels/LabelsContext";
import { Input, Submit } from "../FormComponents";

const defaultErrorMessage = (err) => err?.response?.data?.error_message;

// Login card (form only, moved from the webapp Login). onSubmit({ username, password }) does the
// request and the navigation; if it rejects the fields are cleared and getErrorMessage(err) is shown.
// footer: optional node shown under the form (the webapp puts the "forgot password" link there; the automation
// app does not pass it).
// No style import here: the app loads "@wine2trace/ui/LoginForm/styles/login" (and the Input styles).
const LoginForm = ({ onSubmit, usernamePattern, passwordPattern, getErrorMessage = defaultErrorMessage, footer }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
    mode: "onTouched",
  });
  const [getLabel] = useUiLabels();
  const [errorSubmit, setErrorSubmit] = useState({});

  useEffect(() => {
    document.documentElement.classList.add("login-page");
    return () => document.documentElement.classList.remove("login-page");
  }, []);

  const handleLogin = async (payload) => {
    try {
      await onSubmit(payload);
    } catch (err) {
      reset();
      setErrorSubmit({ error: getErrorMessage(err) });
    }
  };

  const resetError = () => {
    setErrorSubmit(null);
  };

  return (
    <div className="login login_wrapper red_card">
      <h1>{getLabel("title")}</h1>
      <form onSubmit={handleSubmit(handleLogin)} autoComplete="off" noValidate>
        <Input
          name="username"
          register={register}
          regExpPattern={{
            value: usernamePattern,
            message: getLabel("inputPatternError"),
          }}
          type="text"
          label={getLabel("username")}
          placeholder={getLabel("usernamePlaceholder")}
          error={errors["username"]}
          required={getLabel("inputRequiredError")}
          isRequiredTooltip={false}
          onChange={resetError}
        />
        <Input
          name="password"
          register={register}
          regExpPattern={{
            value: passwordPattern,
            message: getLabel("inputPatternError"),
          }}
          type="password"
          label={getLabel("password")}
          placeholder={getLabel("passwordPlaceholder")}
          error={errors["password"]}
          required={getLabel("inputRequiredError")}
          isRequiredTooltip={false}
          onChange={resetError}
          showPasswordToggle={true}
        />
        <Submit customClassName={"is_login"} label={getLabel("loginCTA")} />
        {errorSubmit?.error && <div className="error_submit">{errorSubmit.error}</div>}
      </form>
      {footer && <div className="login_footer">{footer}</div>}
    </div>
  );
};

export default LoginForm;
